import { graphTrpc } from '@org/clients/graph';

export const useInviteStudent = () => graphTrpc.students.invite.useMutation();

